import { DetailsProfileBadge } from 'modules/_shared/components/Sections/DetailsProfileSection';
import { PartnerCategory } from 'types';
import { SocietyCorporateId } from 'types/Society';

type ParseBadgesByCorporateIdProps = {
  corporateId: SocietyCorporateId;
  categories: PartnerCategory[];
  partnerBadge: DetailsProfileBadge | null;
  categoryBadges: DetailsProfileBadge[];
  sindicationBadge: DetailsProfileBadge | null;
};

export const parseBadgesByCorporateId = ({
  corporateId,
  categories,
  partnerBadge,
  categoryBadges,
  sindicationBadge,
}: ParseBadgesByCorporateIdProps): (DetailsProfileBadge | null)[] => {
  if (corporateId === SocietyCorporateId.AXA) {
    const categoriesNoPartner = categories
      ?.filter((category) => category.overridePartner)
      ?.map((category) => category._id);

    if (!categoriesNoPartner?.length) {
      return [partnerBadge, ...categoryBadges, sindicationBadge].filter(
        Boolean
      );
    }
    return [...categoryBadges, sindicationBadge].filter(Boolean);
  }

  return [partnerBadge, ...categoryBadges, sindicationBadge].filter(Boolean);
};
